import { gql } from '@apollo/client';

// Search patients query (for activity creation)
export const SEARCH_PATIENTS_QUERY = gql`
  query SearchPatients($studySiteInvestigatorId: UUID!, $query: String!, $limit: Int = 10) {
    searchPatients(studySiteInvestigatorId: $studySiteInvestigatorId, query: $query, limit: $limit) {
      id
      patientNumber
      screeningNumber
      status
    }
  }
`;
